module.exports = __webpack_public_path__ + "img/phoneFooter.e79e44f9.svg";